import feJsonTemp from "../json/frontend.json";
import CONFIG from '../environmentConfig/index'

const commonHeaders = {
    'Cache-Control': 'no-cache',
}
export const fetchStreamJson = (stream) => {
    return  fetch(`${CONFIG.S3_BASE_URL}/config/${stream}.json`,{
        headers:{
            ...commonHeaders
        }
    })
        .then(res => res.json())
        .then(
            (result) => result,
            (error) => {
                console.log(`fetchStreamJson error in ${stream} is : ${error}`)
            }
        )
}

export const fetchFeJson = () => {
    return fetch(`${CONFIG.S3_BASE_URL}/config/frontend.json`,{
        headers:{
            ...commonHeaders
        }
    })
        .then(res => res.json())
        .then(
            //(result) => require('../json/frontend.json'),
            (result) => result,
            (error) => {
                console.log(`fetchFeJson error is : ${error}`)
            }
        )
}